import {
  AfterContentInit,
  Component,
  OnChanges,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  TemplateRef,
  SimpleChanges,
  Renderer2,
  ChangeDetectorRef,
  effect,
  signal,
  Signal,
  WritableSignal,
  EventEmitter,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { animate, style, transition, trigger } from '@angular/animations';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { CxTableService } from '@projects/shared/src/app/modules/cx-datagrid/services/cx-table.service';
import { ToastService } from '@projects/shared/src/app/services/toast/toast.service';
import { CallRecordingService } from '@projects/admin/src/app/services/call-recording.service';
import { RefreshEvaluationListService } from '../refresh-evaluation-list.service';

@Component({
  selector: 'agent-call-recording-transcript',
  templateUrl: './agent-call-recording-transcript.component.html',
  styleUrls: ['./agent-call-recording-transcript.component.scss'],
})
export class AgentCallRecordingTranscriptComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter();
  @Output() mode = new EventEmitter();
  @Output() export = new EventEmitter();

  @Input() columns: any[] = [];
  @Input() views: any[] = [];
  @Input() module: string = '';

  transcriptData: any[] = [];
  filteredTranscriptData: any[] = [];
  private currentPlayedElem!: HTMLAudioElement;
  transcriptMessageSearch: string = '';
  filter: any = { fields: '', fieldValues: '', criteria: '', limit: 15, skip: 0 };

  constructor(
    public cxtableService: CxTableService,
    private toastService: ToastService,
    public callRecordingService: CallRecordingService,
    private refreshService: RefreshEvaluationListService
  ) {}

  ngOnInit(): void {
    this.fetchTranscript();
  }

  ngOnDestroy(): void {
    this.close.emit('');
    this.refreshService.triggerTooltip();
  }

  fetchTranscript() {
    const CallSid = this.cxtableService.editColumn?.row.CallSid;
    this.callRecordingService.getCallTranscript(CallSid).subscribe({
      next: (response: any) => {
        this.transcriptData = response;
        this.filteredTranscriptData = response;  
      },
      error: (error: any) => {
        // Handle error appropriately
        this.toastService.error('Error fetching transcript.');
      },
      complete: () => {
      },
    });
  }

  playAudioFromSeconds(seconds: number, data: any) {
    let audioRef = data.row['action'];
    if (this.currentPlayedElem && this.currentPlayedElem !== audioRef) {
      this.currentPlayedElem.pause();
    }
    audioRef.currentTime = seconds;
    audioRef.play();
  }

  onClose(e: MouseEvent) {
    e.preventDefault();
    this.close.emit('');
    this.refreshService.triggerTooltip();
  }


  filterMessages() {
    const search = this.transcriptMessageSearch.toLowerCase();
    this.filteredTranscriptData = this.transcriptData.filter((m) =>
      m.message.toLowerCase().includes(search) || m.speaker.toLowerCase().includes(search)
    );
  }
}